var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "global-languages" },
    [
      _c(
        "a",
        {
          staticClass: "btn btn-success waves-effect waves-light text-white",
          on: {
            click: function ($event) {
              return _vm.addNewLang()
            },
          },
        },
        [
          _c("i", { staticClass: "feather icon-plus" }),
          _vm._v("\n        Add New\n    "),
        ]
      ),
      _vm._v(" "),
      _vm.addNewPage
        ? _c("new-crud-language", { attrs: { data: null } })
        : _vm._e(),
      _vm._v(" "),
      _vm.loading ? _c("div", [_vm._v("Loading..")]) : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.filteredLanguages, function (language, key) {
        return _c(
          "div",
          { key: key, staticClass: "global-language pt-05 row" },
          [
            _c("div", { staticClass: "col-12 d-flex align-items-center" }, [
              _c(
                "a",
                {
                  staticClass:
                    "form-control section-button btn btn-primary text-capitalize",
                  attrs: { href: "javascript:" },
                  on: {
                    click: function ($event) {
                      _vm.currentSection = key
                    },
                  },
                },
                [_vm._v(_vm._s(key))]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn-sm btn-danger text-white ml-05",
                  on: {
                    click: function ($event) {
                      return _vm.removeLanguage(key)
                    },
                  },
                },
                [_vm._v("Delete")]
              ),
            ]),
            _vm._v(" "),
            _vm.currentSection === key
              ? _c("new-crud-language", { attrs: { data: language } })
              : _vm._e(),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }